export default function ItalicIcon() {
  return (
    <svg viewBox="0 0 32 32">
      <path d="M28 2v2h-4l-10 24h4v2h-14v-2h4l10-24h-4v-2z" />
    </svg>
  );
}
